webpackJsonp([240994105559750],{

/***/ 444:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"id":"/opt/build/repo/src/pages/articles/06-Complications/01-webmd-complications.md absPath of file >>> MarkdownRemark","frontmatter":{"path":"webmd-complications","title":"When Hepatitis C Worsens (WebMD)","category":"complications","categoryDesc":"Complications","source":"WebMD"}}},{"node":{"id":"/opt/build/repo/src/pages/articles/06-Complications/02-medicinenet-complications.md absPath of file >>> MarkdownRemark","frontmatter":{"path":"medicinenet-complications","title":"What are the complications of undiagnosed hepatitis C?(MedicineNet)","category":"complications","categoryDesc":"Complications","source":"MedicineNet"}}},{"node":{"id":"/opt/build/repo/src/pages/articles/06-Complications/03-nhs-complications.md absPath of file >>> MarkdownRemark","frontmatter":{"path":"nhs-complications","title":"Complications (NHS)","category":"complications","categoryDesc":"Complications","source":"NHS"}}}]}},"pathContext":{"category":"complications"}}

/***/ })

});


// WEBPACK FOOTER //
// path---category-complications-16624b669db491c47281.js